import React from "react";

function Camera({ width = 20, height = 21, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7_22620)">
        <path
          d="M7.50001 3L5.97501 4.66667H3.33334C2.41667 4.66667 1.66667 5.41667 1.66667 6.33333V16.3333C1.66667 17.25 2.41667 18 3.33334 18H16.6667C17.5833 18 18.3333 17.25 18.3333 16.3333V6.33333C18.3333 5.41667 17.5833 4.66667 16.6667 4.66667H14.025L12.5 3H7.50001ZM10 15.5C7.70001 15.5 5.83334 13.6333 5.83334 11.3333C5.83334 9.03333 7.70001 7.16667 10 7.16667C12.3 7.16667 14.1667 9.03333 14.1667 11.3333C14.1667 13.6333 12.3 15.5 10 15.5Z"
          fill={fill}
        />
        <path
          d="M10 14.6667L11.0417 12.375L13.3333 11.3333L11.0417 10.2917L10 8L8.95834 10.2917L6.66667 11.3333L8.95834 12.375L10 14.6667Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_7_22620">
          <rect
            width={width}
            height={width}
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Camera;
